/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadVendorDetails(vendorList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/getvendor`, vendorList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadVendorCategoryDetails(partiesList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/getvendorcategory`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createVendorCategoryDetails(partiesList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/createvendorcategory`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createVendorDetails(vendorList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/createvendor`, vendorList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function updateVendorDetails(vendorList) {
  // let payload = { isMode:2 }

  return await api
    .put(`/org/updatevendor`, vendorList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deleteVendorDetails(vendorList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/deletevendor`, vendorList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadVendorCollectDetails(vendorList) {
  return await api
    .post(`/org/getpartytocollect`, vendorList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadVendorPayDetails(vendorList) {
  return await api
    .post(`/org/getpartytopay`, vendorList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadVendorTransactionDetails(vendorList) {
  return await api
    .post(`/org/getpartytransaction`, vendorList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
const remotes = {
  loadVendorDetails,
  loadVendorCollectDetails,
  loadVendorPayDetails,
  loadVendorTransactionDetails,
  createVendorDetails,
  loadRecordsMetaData,
  updateVendorDetails,
  deleteVendorDetails,
  loadVendorCategoryDetails,
  createVendorCategoryDetails,
};

export default remotes;
